import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { Button, Checkbox, TextField } from '@mui/material';
import Modal from '@mui/material/Modal';
import React, { useContext } from 'react';
import Grid from '@mui/material/Grid';
import Input from '@mui/material/Input';
import FormControlLabel from '@mui/material/FormControlLabel';
import { MeetupContext } from '@/MeetupContext';
import { Link, useParams } from 'react-router-dom';
import { Link as LinkCore } from '@mui/material';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import { RegFormType, SystemFieldType } from '@/api';
import Radio from '@mui/material/Radio';
import { useForm } from 'react-hook-form';
import { ECTextField } from '@/components/Forms/ECTextField';
import { ECRadioGroupField } from '@/components/Forms/ECRadioGroupField';
import { fieldKey } from '../../VisitorList/components/ImportXLS/import_utils';
import { ECMultiCheckboxField } from '@/components/Forms/ECMultiCheckboxField';
import * as _ from 'underscore';
import CardBlock from '@/components/CardBlock/CardBlock';

const PREFIX = 'FormFields';

const classes = {
  groupLabel: `${PREFIX}-groupLabel`,
};

const StyledCardBlock = styled(CardBlock)(({ theme }) => ({
  [`& .${classes.groupLabel}`]: {
    paddingTop: 12, //theme.spacing(1)
  },
}));

const FormFields = props => {
  const { className, fields, regForm, save, ...rest } = props;
  const { mid: meetupId } = useParams();

  const form = useForm();

  const handleSave = data => {
    //save(data, form)
  };

  return (
    <StyledCardBlock title={'Настройка анкеты участника'} form={form} save={handleSave}>
      <Grid container spacing={3} style={{ margin: '0px' }}>
        <Grid size={12}>
          <Typography style={{ color: '#546e7a', marginTop: '8px', marginBottom: '16px' }}>
            В нетворкинге могут участвовать только зарегистрированные посетители.
            <ul style={{ marginLeft: 16 }}>
              <li>Если посетитель регистрировался через чат-бота, то он сможет сразу участвовать в нетворкинге.</li>
              <li>
                Если посетитель был добавлен в систему Eventos другим способом (через форму онлайн-регистрации, либо
                вручную администратором), то бот попросит ввести Email посетителя, указанный при регистрации. Если Email
                будет указан верно, то на него придет числовой код, который надо будет ввести в ботике и тем самым
                подтвердить, что этот Email принадлежит данному посетителю. После успешной проверки будет доступен
                модуль нетворкинга.
              </li>
            </ul>
          </Typography>
        </Grid>

        <Grid style={{ paddingTop: 12 }} size={4}>
          <Typography style={{ color: '#546e7a' }}>Список полей в анкете:</Typography>
        </Grid>
        <Grid size={4}>
          <FormLabel component='legend'>тут список</FormLabel>
        </Grid>
      </Grid>
    </StyledCardBlock>
  );
};

export default FormFields;
